import FieldsInvoiceTerms from './FieldsInvoiceTerms'

export default FieldsInvoiceTerms
